import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-plus\">\n    <g fill=\"currentColor\" fill-rule=\"evenodd\">\n        <path d=\"M6 0h2v14H6z\" />\n        <path d=\"M14 6v2H0V6z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol